module.exports = __webpack_public_path__ + "static/media/021.b0942dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/021.jpg
// module id = 528
// module chunks = 0